<template>
<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{new Date().getFullYear()}} © طلاباش
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    طراحی و توسعه توسط طلاباش
                </div>
            </div>
        </div>
    </div>
</footer>
</template>
